/* Klaily — homepage Trio picker.
   Pick N designs, then add the set-price bundle product to the native cart with
   the chosen designs attached as line-item properties, and open the cart drawer.
   No-ops when the picker isn't on the page, so it's safe to load globally. */
(function () {
  'use strict';

  var root = document.querySelector('[data-home-trio]');
  if (!root) return;

  var REQUIRED = parseInt(root.getAttribute('data-required'), 10) || 3;
  var addBtn = root.querySelector('[data-home-trio-add]');
  var countEl = root.querySelector('[data-pick-count]');
  var msgEl = root.querySelector('[data-pick-msg]');
  var opts = [].slice.call(root.querySelectorAll('[data-design]'));

  var selected = [];   // design names, max REQUIRED

  function isComplete() { return selected.length === REQUIRED; }

  function refresh() {
    opts.forEach(function (o) {
      var on = selected.indexOf(o.getAttribute('data-design')) !== -1;
      o.setAttribute('aria-pressed', String(on));
      o.disabled = !on && isComplete();
    });
    if (countEl) countEl.textContent = selected.length;
    if (msgEl) {
      if (isComplete()) msgEl.textContent = 'trio complete — ready to add ✓';
      else if (selected.length === 0) msgEl.textContent = 'tap ' + REQUIRED + ' designs to build your trio';
      else msgEl.textContent = 'tap ' + (REQUIRED - selected.length) + ' more';
    }
    if (addBtn) addBtn.disabled = !isComplete();
  }

  opts.forEach(function (o) {
    o.addEventListener('click', function () {
      var name = o.getAttribute('data-design');
      var idx = selected.indexOf(name);
      if (idx !== -1) selected.splice(idx, 1);
      else if (selected.length < REQUIRED) selected.push(name);
      refresh();
    });
  });

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (!isComplete()) return;
      var vid = addBtn.getAttribute('data-home-trio-add');
      if (!vid) return;

      var properties = {};
      selected.forEach(function (name, i) { properties['Design ' + (i + 1)] = name; });

      var prev = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      var done = function () { addBtn.textContent = prev; refresh(); };

      var body = { id: vid, quantity: 1, properties: properties };
      // Reuse the cart engine's optimistic add — paints the line instantly from
      // these data-opt-* attrs, then opens + reconciles the drawer.
      if (window.klailyAddToCart) {
        var opt = {
          title: addBtn.getAttribute('data-opt-title'),
          price: parseInt(addBtn.getAttribute('data-opt-price'), 10) || 0,
          image: addBtn.getAttribute('data-opt-image') || '',
          url: addBtn.getAttribute('data-opt-url') || '',
          properties: properties
        };
        window.klailyAddToCart(body, opt).then(done, done);
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function () {
            if (window.klailyRefreshDrawer) {
              return window.klailyRefreshDrawer().then(function () {
                if (window.klailyOpenCart) window.klailyOpenCart();
              });
            }
            if (window.klailyOpenCart) window.klailyOpenCart();
          })
          .catch(function () {})
          .then(done);
      }
    });
  }

  refresh();
})();
